
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsf15505896e8c9114151180cfd5bc1108en from './en.yaml'
            i18n.addResourceBundle('en', 'f15505896e8c9114151180cfd5bc1108', flattenObject(nsf15505896e8c9114151180cfd5bc1108en), true, true);
        
        export default 'f15505896e8c9114151180cfd5bc1108';
    